import React, { useEffect, useContext } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import Loader from '../components/misc/loader';
import { Context as RestaurantContext } from '../context/restaurant';
import { Context as AuthContext } from '../context/auth';
import { Context as CartContext } from '../context/cart';
import { Context as CheckoutContext } from '../context/checkout';
import { activeTable } from '../services/tableService';
import { useInterval } from '../hooks/useInterval';
import { restaurantTypes } from '../enums/restaurantTypes';
import { calculateCartSum } from '../services/cartService';

const InitPage = ({ children }) => {
  const navigate = useNavigate();
  const { search } = useLocation();

  const scanId = new URLSearchParams(search).get('scanId');
  const type = new URLSearchParams(search).get('type');

  const isFromScan = !!scanId;

  const {
    state: restaurantState,
    getTable,
    autoRefreshProductsLocal,
  } = useContext(RestaurantContext);
  const { initUser } = useContext(AuthContext);
  const {
    state: cartState,
    initCart,
    autoRefreshCartLocal,
    autoRefreshDeliveryCartLocal,
  } = useContext(CartContext);
  const { state: checkoutState, autoRefreshOrderBill } = useContext(CheckoutContext);

  const getTableFromScan = async () => {
    const { locked } = await getTable({ tableQr: scanId });
    if (!locked) {
      initUser();
      initCart();
      navigate('/', { replace: true });
    }
  };

  useEffect(() => {
    if (type === 'table' && scanId) {
      getTableFromScan();
    }
  }, [scanId, type]);

  useEffect(() => {
    if (isFromScan || restaurantState.tableGot) {
      return;
    }

    const getTableAsync = async () => {
      await getTable({ tableQr: activeTable.qr });
      initUser();
      initCart(activeTable.id);
    };

    getTableAsync();
  }, []);

  // useEffect(() => {
  //   initUser();
  // }, []);

  // Refresh product schedules and discounts
  useInterval(
    () => {
      const { categories: updatedCategories, refreshed: productsRefreshed } =
        autoRefreshProductsLocal();

      if (
        productsRefreshed &&
        restaurantState.restaurant &&
        restaurantState.restaurant.type === restaurantTypes.OrderAndPay
      ) {
        let cartRefreshed;
        let updatedTotalDiscounted;
        let updatedCart;

        // delivery
        if (cartState.deliveryCartSlug) {
          const {
            refreshed: refreshedTemp,
            totalDiscounted: totalDiscountedTemp,
            cart: cartTemp,
          } = autoRefreshDeliveryCartLocal(restaurantState.discountCartService, updatedCategories);

          cartRefreshed = refreshedTemp;
          updatedTotalDiscounted = totalDiscountedTemp;
          updatedCart = cartTemp;
        }
        // at restaurant
        else {
          const {
            refreshed: refreshedTemp,
            totalDiscounted: totalDiscountedTemp,
            cart: cartTemp,
          } = autoRefreshCartLocal(
            restaurantState.restaurant.id && restaurantState.discountCartService,
            updatedCategories,
          );

          cartRefreshed = refreshedTemp;
          updatedTotalDiscounted = totalDiscountedTemp;
          updatedCart = cartTemp;
        }

        if (cartRefreshed && checkoutState.bill) {
          autoRefreshOrderBill({
            subtotal: calculateCartSum({ cart: updatedCart }),
            discount: updatedTotalDiscounted,
            cart: updatedCart,
          });
        }
      }
    },
    20000,
    false,
    [
      restaurantState.apiProducts,
      restaurantState.apiCategories,
      restaurantState.apiDiscounts,
      restaurantState.apiVariationJoins,
      restaurantState.restaurant,
      restaurantState.discountMenuService,
      restaurantState.discountCartService,
      cartState.cart,
      cartState.deliveryCart,
      checkoutState.bill,
    ],
  );

  // Loading table
  if (restaurantState.loadingTable || !restaurantState.tableGot) {
    return <Loader />;
  }

  // No table found in DB
  /* if (isFromScan && restaurantState.tableGot && !restaurantState.table) {
    return (
      <MainLayout>
        <div className="mx-auto mt-20">
          <h1 className="font-primaryMedium text-2xl text-primary text-center">
            {t('home.noTableScanned')}
          </h1>
        </div>
      </MainLayout>
    );
  } */

  return children;
};

export default InitPage;
